<template>
    <div class="event-ticket">
        <div class="row mb-1 mb-md-2">
            <div class="col-12 d-flex flex-column flex-md-row align-items-center justify-content-between">
                <!--page title and event summary-->
                <h1 class="pl-2 m-0 h1-responsive text-uppercase d-flex justify-content-between align-items-center">
                    <span v-if="order_tickets_action"
                          class="mt-1 d-flex justify-content-between align-items-center"
                    >
                        <i class="mr-1 secondary-text" :class="nav_names.order.icon"></i>Tickets <span
                            class="font-weight-bold"
                    >{{nav_names.order.title}}</span>
                    </span>

                    <span v-else-if="override_tickets_action"
                          class="mt-1 d-flex justify-content-between align-items-center"
                    >
                        <i class="mr-1 secondary-text" :class="nav_names.override.icon"></i>Tickets <span
                            class="font-weight-bold"
                    >{{nav_names.override.title}}</span>
                    </span>

                    <span v-else-if="wastage_tickets_action"
                          class="mt-1 d-flex justify-content-between align-items-center"
                    >
                        <i class="mr-1 secondary-text" :class="nav_names.wastage.icon"></i>Tickets <span
                            class="font-weight-bold"
                    >{{nav_names.wastage.title}}</span>
                    </span>

                    <span v-else
                          class="mt-1 d-flex justify-content-between align-items-center"
                    >
                        <i
                                class="mr-1 secondary-text"
                                :class="nav_names.config.icon"
                        ></i>Tickets <span
                            class="font-weight-bold"
                    >{{nav_names.config.title}}</span>
                    </span>

                    <add_to_bookmark
                            :store="bookmark_store"
                            :route="bookmark_route"
                    ></add_to_bookmark>

                    <button
                            v-on:click="show_sub_navigation = !show_sub_navigation"
                            class="btn btn-floating btn-primary">
                        <i class="material-icons fs-3">settings</i>
                    </button>
                </h1>
                <!--the descriptions-->
                <div class="text-right">
                    <a :href="web_address" target="_blank">
                        <div class="font-weight-bold text-uppercase">
                            {{langData('title',event_details.event_data)}}
                        </div>
                        <div>
                            <div>
                                {{formatDate(event_details.start_date)}}
                            </div>
                            <div class="font-weight-bold">
                                {{formatDateToTime(event_details.start_date)}}
                                -
                                {{formatDateToTime(event_details.end_date)}}
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
        <div class=" mb-sm-5">
            <event-ticket-nav v-if="show_sub_navigation"
                              :nav_names="nav_names"
                              :nav_restrictions="nav_restrictions"
                              :order_tickets_action="order_tickets_action"
                              :override_tickets_action="override_tickets_action"
                              :wastage_tickets_action="wastage_tickets_action"
                              :config_tickets_action="config_tickets_action"
                              @nav_event="NavEventHandler"
            >
            </event-ticket-nav>
        </div>

        <!-- wastage alert -->
        <div v-if="wastage_applied_toself_event">
            <div class="alert alert-danger" role="alert">
                <h5>This event has wastage - Make me pretty KENI</h5>
                <h4 class="alert-heading">This event has wastage</h4>
                <p>Wastage has been applied to tickets within this event.</p>
                <hr>
                <p class="mb-0">Whenever you need to see wastage tickets click here</p>
            </div>
        </div>

        <!--ticket order page-->
        <div v-if="order_tickets_action">

            <rearrange-list :params="{
                    routes:{
                        read:   content.urls.url,
                        update: content.urls.update_ticket_order,
                        data:   null
                    },
                    collection:{
                        name:   'tickets',
                        list:ticketsToEntities
                    }
                }"
            ></rearrange-list>
        </div>
        <!--ticket overrides page-->
        <div v-if="override_tickets_action">
            <event-ticket-override
                    @event="EventHandler"
                    :ticketsToEntities="ticketsToEntities"
                    :event_details="event_details"
                    :url="urls.override"
                    :lang="lang"
            ></event-ticket-override>
        </div>
        <!--wastage page-->
        <div v-if="wastage_tickets_action">
            <wastage-page
                    :content="{
                    read_url: urls.wastage_routes.read_url,
                    create_url: urls.wastage_routes.create_url,
                    update_url: urls.wastage_routes.update_url,
                    export_url: urls.wastage_routes.export_url,
                    close_url: urls.wastage_routes.close_url,
                    send_emails_url: urls.wastage_routes.send_emails_url,
                }"
            ></wastage-page>
        </div>
        <!--tickets config page-->
        <section v-if="showConfigPage()"
                 class="watch-transition--fast"
                 :class="{
        'pt-5':accordion_action,
        'pt-2':!accordion_action

        }"
        >
            <!--event ticket summary-->
            <section id="event-ticket--summary">
                <div class="row mt-3 mb-2 mb-md-0">
                    <div class="col-12 col-md-4 pt-5 pb-2 pt-md-0 pb-md-0"
                         v-for="(ticket_type, ticket_idx) in summary.tickets">
                        <ul class="list-group"
                            :class="{
                    'z-depth-2':summary.tickets[ticket_idx].active === true,
                    'z-depth-1':summary.tickets[ticket_idx].active !== true
                }"
                        >
                            <li v-on:click="filterTicketType(ticket_idx)"
                                class="list-group-item list-group-item-header  header d-flex justify-content-between align-items-center"
                                :class="{active:summary.tickets[ticket_idx].active === true}"
                            >
                                <span class="text-nowrap text-uppercase text-center">
                                    <i class="list-group-item-header--icon fa " :class="ticketType(ticket_idx)"/>
                                    <span v-if="ticket_idx === 'total'" class="list-group-item-header--counter"><span>{{summary.count}}</span></span>
                                    <span v-if="ticket_idx !== 'total'" class="list-group-item-header--counter"><span>{{ticket_type.count}}</span></span>
                                    <span class="list-group-item-header--title">{{ticket_idx}} tickets</span>
                                </span>
                            </li>
                            <!--Allocation-->
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <span class="text-nowrap text-capitalize">allocated</span>
                                <span class="text-right font-weight-bold">
                                    <span class="badge badge-primary badge-pill"> {{ticket_type.allocated}}</span>
                                </span>
                            </li>
                            <!--Used-->
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <span class="text-nowrap text-capitalize">used</span>
                                <span class="text-right font-weight-bold">
                                    <span class="badge badge-primary badge-pill"> {{ticket_type.used}}</span>
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
            <section class="event-ticket--ticket">
                <!--view switcher import ticket, grid | list, view as groups and title-->
                <div class="row mt-5">
                    <div class="col-md-4">
                        <div class="h4-responsive align-items-center d-flex justify-content-between">
                            <div>Tickets assigned</div>
                            <div class="">
                                <!--//grid switcher-->
                                <button v-show="layout.current === 'grid'" type="button"
                                        class="btn bg-primary btn-floating"
                                        v-bind:class="{
                                'active': layout.current === 'grid',
                                'd-none':layout.current === 'grid',
                                'd-md-inline-block':layout.current === 'grid'
                            }"
                                        v-on:click="switchLayout('list')"
                                >
                                    <i class="material-icons mt-0" aria-hidden="true">view_headline</i>
                                </button>
                                <button v-show="layout.current === 'list'" type="button"
                                        class="btn bg-accent btn-floating"
                                        v-bind:class="{
                                'active': layout.current === 'list',
                                'd-none':layout.current === 'list',
                                'd-md-inline-block':layout.current === 'list'

                                }"
                                        v-on:click="switchLayout('grid')"
                                >
                                    <i class="material-icons mt-0" aria-hidden="true">toc</i>
                                </button>

                                <!--show group toggle-->
                                <button v-if="group_by_entity===true"
                                        v-on:click="switchGroupByEntity()"
                                        class="btn bg-info btn-floating active"
                                >
                                    <i class="material-icons mt-0" aria-hidden="true">view_stream</i>
                                </button>
                                <button v-else
                                        v-on:click="switchGroupByEntity()"
                                        class="btn bg-accent btn-floating active"
                                >
                                    <i class="material-icons mt-0" aria-hidden="true">view_module</i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <!--Add Entity-->
                    <div v-if="!restrict_entity_import" class="col-md-4">
                        <div id="entity-material_select--wrapper">
                            <material-select :content="{emit_controller:material_select_controllers.entity}"
                                             ref="entity_chooser_select" :id="entity_chooser.id"
                                             @material_select_entity_result="materialEntitySelectItemSelected"
                                             @material_select_entity_submit="materialEntitySelectItemSelected"
                            />
                        </div>
                        <!--<transition name="fade">-->
                        <!--<div v-if="entity_selected_to_import" class="col-auto">-->
                        <!--<button class="btn btn-amber"-->
                        <!--v-bind:class="entity_selected_to_import ? '' : 'disabled'"-->
                        <!--v-on:click="importEntity(entity_selected_to_import)">Import entities-->
                        <!--</button>-->
                        <!--</div>-->
                        <!--</transition>-->
                    </div>
                    <div class="col-md-4" v-else></div>

                    <!--Add ticket-->
                    <div v-if="!restrict_ticket_import" class="col-md-4">
                        <div id="material_select--wrapper">
                            <material-select :content="{emit_controller:material_select_controllers.ticket}"
                                             ref="ticket_chooser_select" :id="ticket_chooser.id"
                                             @material_select_result="materialSelectItemSelected"
                                             @material_select_submit="materialSelectItemSelected"
                            />
                        </div>
                        <!--<transition name="fade">-->
                        <!--<div v-if="ticket_selected_to_import" class="col-auto">-->
                        <!--<button class="btn btn-amber"-->
                        <!--v-bind:class="ticket_selected_to_import ? '' : 'disabled'"-->
                        <!--v-on:click="importTicket(ticket_selected_to_import)">Import tickets-->
                        <!--</button>-->
                        <!--</div>-->
                        <!--</transition>-->
                    </div>
                    <div class="col-md-4" v-else></div>
                </div>
                <!--grouped by entity-->
                <section data-ref="group_by_entity" v-if="group_by_entity === true || only_group_by_entity === true" data-grouped-by-entity="true">
                    <div class="" v-for="entityTicket in ticketsToEntities"
                         :class="{
                            'border border-secondary p-3 z-depth-1 bg-light mb-3' :Object.keys(entityTicket).length > 0
                        }"
                    >
                        <!--entity counts like allocated etc...-->
                        <div v-if="entityTicket.length > 0"
                             class="d-block d-sm-flex align-items-center justify-content-sm-between"
                        >
                            <h4 class="text-light text-center h4-responsive m-0">
                                {{entityTicket[0].entity.entity_data.lang.en_GB.title}}

                            </h4>
<!--                            Capacity-->
                            <div class="d-block d-sm-flex align-items-center justify-content-sm-between">
                                <div class="mt-2 mr-0 mr-sm-2 mb-0 ml-0 d-flex justify-content-between align-items-center ">
                                    <div class="text-light mr-2">Capacity:</div>
                                    <div class="badge badge-primary badge-pill">{{entityTicket[0].entity.entity_data.capacity}}
                                    </div>
                                </div>
<!--                                Allocated-->
                                <div class="mt-2 mr-0 mr-sm-2 mb-0 ml-0 d-flex justify-content-between align-items-center">
                                    <div class="text-light mr-2">Allocated:</div>
                                    <div class="badge badge-pill"
                                         v-bind:class="entities_cache[entityTicket[0].entity.id].allocated > entityTicket[0].entity.entity_data.capacity ? 'badge-danger' : 'badge-primary'"
                                    >
                                        {{entities_cache[entityTicket[0].entity.id].allocated}}
                                    </div>
                                </div>
<!--                                Used-->
                                <div class="mt-2 mr-0 mr-sm-2 mb-0 ml-0 d-flex justify-content-between align-items-center">
                                    <div class="text-light mr-2">Used:</div>
                                    <div class="badge badge-pill"
                                         v-bind:class="'badge-primary'"
                                    >
                                        {{entities_cache[entityTicket[0].entity.id].sold}}
                                    </div>
                                </div>
<!--                                Remaining-->
                                <div class="mt-2 mb-0 ml-0 d-flex justify-content-between align-items-center">
                                    <div class="text-light mr-2">Remaining:</div>
                                    <div class="badge badge-pill"
                                         v-bind:class="entities_cache[entityTicket[0].entity.id].allocated > entityTicket[0].entity.entity_data.capacity ? 'badge-danger' : 'badge-primary'"
                                    >
                                        {{entities_cache[entityTicket[0].entity.id].allocated > entityTicket[0].entity.entity_data.capacity?entityTicket[0].entity.entity_data.capacity - entities_cache[entityTicket[0].entity.id].sold:   entities_cache[entityTicket[0].entity.id].allocated - entities_cache[entityTicket[0].entity.id].sold}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--entity tickets list-->
                        <div class="__body">
                            <transition-group class="row row-equal-height" name="expandTopLeftDown" tag="div">
                                <div v-for="(ticket,index) in entityTicket"
                                     :id="'item-'+ticket.id"
                                     class="mt-3 watch-transition ticket-items d-flex"
                                     :class="{
                                     'col-md-6 col-lg-4' : layout.current === 'grid',
                                     'col-12' : layout.current === 'list'
                                 }" v-bind:key="index"
                                >
                                    <div :id="'card-selected-'+ticket.id"
                                         class="col watch-transition--fast card card-outline-dummy card-cascade cascading-admin-card"
                                         :class="[{
                                            'card--disabled':edit_mode===true && ticket.edit_mode !== true,
                                            'card--active ':ticket.edit_mode === true
                                          },
                                          last_ticket === ticket.id ? 'z-depth-3' : 'z-depth-1'
                                          ]"
                                    >

                                        <!--the thumbnail-->
                                        <event-ticket-thumb :ticket="ticket"
                                                            :ticket_types="ticket_types"
                                                            :methods_available="$options.methods"
                                                            :current_ticket="current_ticket"
                                                            :ticket_edit_url="urls.ticket_edit_url"
                                                            @event="EventHandler"
                                        />

                                        <div class="card-body p-0 pt-3">
                                            <!--edit mode-->
                                            <div v-if="ticket.edit_mode === true"
                                                 @keyup.enter="editTicket(ticket,'item-'+ticket.id)"
                                            >
                                                <event-ticket-mode-edit
                                                        @event="EventHandler"
                                                        :methods_available="$options.methods"
                                                        :current_ticket="current_ticket"
                                                        :ticket="ticket"
                                                        :lang="lang"
                                                        :add_time_slot="add_time_slot"
                                                        :loading="loading"
                                                        :urls="urls"
                                                        :index="index"
                                                />
                                            </div>
                                            <!--initial view-->
                                            <div data-ref="event-ticket-mode-view" v-else>
                                                <event-ticket-mode-view
                                                        :ticket="ticket"
                                                        :layout="layout"
                                                        :lang="lang"
                                                        :methods_available="$options.methods"
                                                        :ticket_edit_url="urls.ticket_edit_url"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </transition-group>
                        </div>
                    </div>
                </section>
                <!--not grouped by entity-->
                <section v-else class="row" data-grouped-by-entity="false">
                    <template data-element-type="loop" v-for="entityTicket in ticketsToEntities">
                        <div data-element-type="item-loop" v-for="(ticket,index) in entityTicket"
                             :id="'item-'+ticket.id"
                             class="watch-transition ticket-items d-flex"
                             :class="{
                                 'col-md-6' : (layout.current === 'grid'),
                                 'col-12' : (layout.current === 'list')
                             }"
                             v-bind:key="ticket.id"
                        >

                            <div :id="'card-selected-'+ticket.id"
                                 class="col watch-transition card card-outline-dummy card-cascade cascading-admin-card mb-4 mb-md-5"
                                 :class="[{'card--disabled':edit_mode==true && ticket.edit_mode !== true,
                                        'bg-white':ticket.edit_mode === true,
                                        'bg-info':ticket.edit_mode !== true
                                      },last_ticket == ticket.id ? 'z-depth-3' : 'z-depth-1']"
                            >
                                <!--the thumbnail-->
                                <event-ticket-thumb :ticket="ticket"
                                                    :ticket_types="ticket_types"
                                                    :methods_available="$options.methods"
                                                    :current_ticket="current_ticket"
                                                    @event="EventHandler"
                                ></event-ticket-thumb>
                                <div class="card-body p-0 pt-3">
                                    <!--edit mode-->
                                    <div v-if="ticket.edit_mode === true"
                                         @keyup.enter="editTicket(ticket,'item-'+ticket.id)"
                                    >
                                        <event-ticket-mode-edit
                                                @event="EventHandler"
                                                :methods_available="$options.methods"
                                                :current_ticket="current_ticket"
                                                :ticket="ticket"
                                                :lang="lang"
                                                :add_time_slot="add_time_slot"
                                                :loading="loading"
                                                :urls="urls"
                                                :index="index"
                                        ></event-ticket-mode-edit>
                                    </div>
                                    <!--initial view-->
                                    <div v-else class="col">
                                        <event-ticket-mode-view
                                                :ticket="ticket"
                                                :layout="layout"
                                                :lang="lang"
                                                :methods_available="$options.methods"
                                                :ticket_edit_url="urls.ticket_edit_url"
                                        ></event-ticket-mode-view>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </section>
            </section>
            <!--confirm action-->
            <div class="modal fade" id="event-ticket--confirm_alert" tabindex="-1" aria-hidden="true">
                <div class="modal-dialog modal-notify modal-danger" role="document">
                    <!--Content-->
                    <div class="modal-content">
                        <!--Header-->
                        <div class="modal-header">
                            <p class="heading">Confirm</p>

                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true" class="white-text">×</span>
                            </button>
                        </div>

                        <div v-html="confirm_alert.message" class="modal-body">
                        </div>

                        <div class="modal-footer justify-content-center">
                            <a type="button"
                               v-on:click="confirm_alert.call_back(confirm_alert.arg)"
                               data-dismiss="modal"
                               class="btn btn-primary-modal waves-effect"
                            >Yes<i class="fa fa-cross ml-1"></i></a>

                            <a type="button"
                               class="btn btn-outline-secondary-modal waves-effect"
                               data-dismiss="modal"
                            >Cancel
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import {getByPath} from '../../../helpers/arraysAndObjects';
    import {
        format as formatMoney,
        isInt,
        isFloat
    } from '../../../../../../app/Shared/Resources/Assets/js/helpers/money';
    import {uniqueId} from '../../../../../../app/Shared/Resources/Assets/js/helpers/classesAndIds';
    import {clone} from '../../../helpers/arraysAndObjects';
    import {_} from 'underscore';
    import MaterialSelect from '../../../components/forms/select/MaterialSelect.vue';
    import EventTicketProps from '../../../components/pages/ticketing/EventTicketProps.vue';
    import {debounce} from 'underscore';

    import {HUB} from '../../../config';
    import updateTheme from '../../../helpers/theme-manager';
    import lang from '../../../../../../app/Shared/Resources/Assets/js/helpers/lang';
    // imported components
    Vue.component(
        'event-ticket-nav', require('./EventTicketNav.vue')
    );
    Vue.component(
        'event-ticket-thumb', require('./EventTicketThumbnail.vue')
    );
    Vue.component(
        'event-ticket-mode-edit', require('./EventTicketModeEdit.vue')
    );
    Vue.component(
        'event-ticket-mode-view', require('./EventTicketModeView.vue')
    );
    Vue.component(
        'rearrange-list', require('../../lists/RearrangeOrderList.vue')
    );
    Vue.component(
        'wastage-page', require('../../pages/wastage/WastagePage.vue')
    );
    Vue.component(
        'event-ticket-override', require('./EventTicketOverride.vue')
    );
    export default {
        components: {
            'material-select': MaterialSelect,
            'event-ticket-props': EventTicketProps
        },
        props: [
            'content', 'bookmark_store', 'bookmark_route', 'restrict_ticket_import', 'restrict_entity_import',
            'nav_restrictions', 'ticket_edit_url','web_address'
        ],
        ready() {
            this.$root.$on('material_select_result', () => {
                alert('event was heard');

            });
        },
        mounted() {
            // console.log('this.content.theme', this.content.theme);
            this.urls.url = this.content.urls.url;
            this.event_details = this.content.event_details;
            // console.log('this.event_details',this.event_details);
            this.urls.add_ticket_url = this.content.urls.add_ticket_url;
            this.urls.override = this.content.urls.override;
            this.urls.remove_ticket_url = this.content.urls.remove_ticket_url;
            this.urls.update_ticket_url = this.content.urls.update_ticket_url;
            this.urls.attributes_ticket_url = this.content.urls.attributes_ticket_url;
            this.urls.all_tickets_url = this.content.urls.all_tickets_url;
            this.urls.ticket_edit_url = this.content.urls.ticket_edit_url;
            this.urls.ticket_create_url = this.content.urls.ticket_create_url;
            this.urls.wastage_routes = this.content.urls.wastage_routes;
            this.urls.all_entities_url = this.content.urls.all_entities_url;
            this.urls.add_entity_url = this.content.urls.add_entity_url;
            // console.log('mounted', 'this.nav_restrictions', this.nav_restrictions);
            if (this.nav_restrictions) {
                for (let navRestrictionsKey in this.nav_restrictions) {
                    let restriction = this.nav_restrictions[navRestrictionsKey];
                    // console.log('mounted', 'restriction', restriction);
                }
            }

            this.event_id = this.content.event_id;

            this.lang = this.content.lang;
            this.currency = this.content.currency;
            this.loadTickets();
            if (this.content.theme) {
                if ('group_by_entity' in this.content.theme) {
                    this.group_by_entity = this.content.theme.group_by_entity;
                }
                if ('grid' in this.content.theme) {
                    this.layout.current = this.content.theme.grid;
                }
            }

            // console.log('mounted', 'this.wastage_tickets_action', this.wastage_tickets_action);
            // console.log('mounted', 'this.restrict_ticket_import', this.restrict_ticket_import);
        },
        data() {
            return {
                show_sub_navigation: false,
                event_details: {},
                accordion_action: false,
                nav_names: {
                    config: {
                        title: 'Config',
                        button: 'Config',
                        icon: 'fa fa-cogs',
                        action: 'toggle'
                    },
                    override: {
                        title: 'Override',
                        button: 'Override',
                        icon: 'fa fa-bolt',
                        action: 'accordion'
                    },
                    order: {
                        title: 'Order',
                        button: 'Display Order',
                        icon: 'fa fa-list-ol',
                        action: 'toggle'
                    },
                    wastage: {
                        title: 'Wastage',
                        button: 'Wastage',
                        icon: 'fa fa-trash',
                        action: 'toggle'
                    }
                },
                show_config_page: false,
                config_tickets_action: true,
                order_tickets_action: false,
                override_tickets_action: false,
                wastage_tickets_action: false,
                urls: {
                    url: '',
                    add_ticket_url: '',
                    remove_ticket_url: '',
                    update_ticket_url: '',
                    attributes_ticket_url: '',
                    all_tickets_url: '',
                    ticket_edit_url: '',
                    ticket_create_url: ''

                },
                add_time_slot: {
                    start: '',
                    end: ''
                },
                theme_page: 'event_tickets',
                layout: {
                    current: 'grid',
                    previous: null
                },
                summary: {
                    count: 0,
                    tickets: {}
                },
                material_select_controllers: {
                    ticket: 'ticket_chooser_select',
                    entity: 'entity_chooser_select'
                },
                ticket_chooser: {
                    id: ''
                },

                entity_chooser: {
                    id: ''
                },
                ticket_attribute_chooser: {
                    id: ''
                },
                group_by_entity: true,
                only_group_by_entity:true,
                loading: false,
                event_id: '',
                ticketsOriginal: [],
                ticketsToEntities: {}, // after retrieving the tickets with entity relationship,
                ticketEntitySummary: {},
                // compile the tickets to be used on the model
                lang: 'en_GB',
                currency: 'GBP',
                edit_mode: false,
                editing_attributes: false,
                gridColumnWidth: 'col-md-4',
                ticket_types: {
                    'single': {
                        icon: 'ticket'
                    },
                    'season': {
                        icon: 'season-ticket'
                    },
                    'bulk': {
                        icon: 'bulk-ticket'
                    },
                    'vip': {
                        icon: 'vip-ticket'
                    }
                },
                entities_select_items: {},
                ticket_select_items: {},
                ticket_select_attributes: {},
                current_ticket: {},
                tickets_cache: {},
                entities_cache: {},
                last_ticket: '',
                materialSelect: [],

                wastage_applied_toself_event: false,

                ticket_selected_to_import: null,
                entity_selected_to_import: null,
                confirm_alert: {
                    message: '',
                    call_back: null,
                    arg: null
                }
            };
        },
        computed:{

        },
        methods: {
            loadTickets() {
                this.ticketsOriginal = [];
                this.ticketsToEntities = {}; // after retrieving the tickets with entity relationship,
                this.ticketEntitySummary = {};
                this.readAllTicketsAssignableForImport();
                this.readAllEntitiesAssignableForImport();
                // this.readEntities();
                this.readTickets();
            },
            showConfigPage() {
                if (this.accordion_action == true) {
                    this.show_config_page = true;
                    return true;
                }

                let self = this,
                    list = [
                        self.order_tickets_action,
                        self.override_tickets_action,
                        self.wastage_tickets_action
                    ],
                    canShow = false;

                canShow = list.every(function (i) {
                    return i == false;
                });
                return canShow;
            },
            langData(path, data) {
                if (typeof data !== 'undefined' && data !== null) {
                    return lang(path, data.lang);
                }
                return null;
            },
            orderTickets() {
                // will present order tickets modal
                this.order_tickets_action = !this.order_tickets_action;
            },

            /**
             * Handles triggers from the navigation
             */
            NavEventHandler(params) {
                let self = this,
                    actionList = [
                        'config_tickets_action',
                        'order_tickets_action',
                        'override_tickets_action',
                        'wastage_tickets_action'
                    ];

                for (let i = 0; i < actionList.length; i++) {
                    let action = actionList[i];

                    self[action] = false; // update all show or hide actions

                }
                self[params.action] = true;
                // console.log('params.action', params.action);
                self.accordion_action = params.toggle;
                if (params.action == 'config_tickets_action') {
                    this.readTickets();
                    this.readAllTicketsAssignableForImport();
                    this.readAllEntitiesAssignableForImport();
                }
            },
            /**
             * Handles all events parsed via emit using the target set in the component
             */
            EventHandler(params) {
                switch (params.action) {
                    case 'reload':
                        this.readTickets();
                        break;
                    case 'event_ticket_attributes__open_close_full':
                        let attribute_key = params.items.value.key,
                            value = params.items.value.value,
                            data = [
                                'ticket_data', 'entity_type_data', 'entity_type_fields', 'groups', 'open_close_full',
                                'items', attribute_key, 'value'
                            ],

                            // this will update the current ticket value
                            processed_record = this.readEventTicketAttribute(this.current_ticket, 'open_close_full',
                                [attribute_key, 'value'], data);

                        // check if the current ticket has a open_close record

                        let record = _.find(this.current_ticket.ticket_event_attributes, {type: 'open_close_full'});

                        if (typeof record === 'undefined' || record === null) {
                            record = {
                                ticket_id: this.current_ticket.id,
                                event_id: this.event_id,
                                type: 'open_close_full',
                                status: 'active',

                                ticket_event_attribute_data: {
                                    open_time: {
                                        value: ''
                                    },
                                    close_time: {
                                        value: ''
                                    }
                                }
                            };
                            // create the record first
                            this.current_ticket.ticket_event_attributes.push(record);
                        }

                        // update the value
                        record.ticket_event_attribute_data[attribute_key].value = value;

                        break;
                    case 'edit':
                        this.editTicket(params.items.ticket, params.items.value);
                        break;
                    case 'ultra-edit':
                        this.ultraEditTicket(params.items.ticket);
                        break;
                    case 'delete':
                        this.deleteTicketConfirm(params.items.ticket);
                        break;
                    case 'editing_attributes':
                        this.editing_attributes = params.items.value;
                        break;
                    case 'loading':
                        this.loading = params.items.value;
                        break;
                    case 'current_ticket_status':
                        this.current_ticket.ticket_event_attributes[params.items.index].status = params.items.value;
                        break;
                    case 'event_ticket_attributes':
                        this.current_ticket.ticket_event_attributes.push(params.items.value);
                        break;
                    case 'clear_time_slots':
                        this.add_time_slot = {
                            start: '',
                            end: ''
                        };
                        break;
                    case 'edit_ticket':
                        let ticket = params.items.ticket;
                        this.editTicket(ticket, 'item-' + ticket.id);
                        break;
                    case 'reset_form':
                        this.resetForm(params.items.ticket);
                        break;
                }
            },
            log(log) {
                console.log(log);
            },
            switchLayout(switchLayout) {
                this.layout.current = switchLayout;
                updateTheme({
                    page: this.theme_page,
                    prop: 'layout',
                    data: {
                        'grid': switchLayout
                    }
                });
            },
            switchGroupByEntity() {
                this.group_by_entity = !this.group_by_entity;

                updateTheme({
                    page: this.theme_page,
                    prop: 'layout',
                    data: {
                        'group_by_entity': this.group_by_entity
                    }
                });
            },
            readTicketAttribute(ticket, type) {
                if (ticket.ticket_data.hasOwnProperty('attributes')) {
                    for (let i = 0; i < ticket.ticket_data.attributes.length; ++i) {
                        let item = ticket.ticket_data.attributes[i];
                        if (item.hasOwnProperty('slug') && item.slug == type) {
                            if (item.icon.hasOwnProperty('fa')) {
                                return `ticket-attribute ticket-attribute--${type} `;
                                // return `ticket-attribute ticket-attribute--${type} fa ${item.icon.fa}`;
                            } else if (item.icon.hasOwnProperty('icomoon')) {
                                return `ticket-attribute ticket-attribute--${type} `;
                                // return `ticket-attribute ticket-attribute--${type} ${item.icon.icomoon}`;
                            }
                        }
                        // console.log('ticket.ticket_data.attributes[i]', ticket.ticket_data.attributes[i]);
                    }
                }
                return '';
            },

            filterTicketType(ticketType) {
                // console.log( 'ticketType', ticketType,this.summary.tickets.length);

                for (let ticket in this.summary.tickets) {
                    // console.log('ticket', ticket, this.summary.tickets[ticket]);
                    if (ticket == ticketType) {
                        this.summary.tickets[ticket].active = true;
                    } else {
                        this.summary.tickets[ticket].active = false;
                    }
                }

                for (let i = 0; i < this.summary.tickets.length; i++) {
                    console.log('summary[i]', summary[i]);
                }

                this.ticketsToEntities = clone(this.ticketsOriginal);

                let tickets = this.ticketsToEntities,
                    type = ticketType;

                if (ticketType === 'total') {
                    return;
                }
                for (let entitySlug in this.ticketsToEntities) {
                    if (!tickets.hasOwnProperty(entitySlug)) {

                        tickets[entitySlug] = [];
                    }
                    // console.log('entity',this.ticketsToEntities[entity]);
                    tickets[entitySlug] = this.ticketsToEntities[entitySlug].filter(function (item) {
                        // console.log('item',item);
                        if (item.ticket_type === type) {
                            return item;
                        }
                    });

                }
                this.ticketsToEntities = tickets;
            },
            importTicket(ticket_ids) {

                console.warn('importTicket');
                let self = this;
                for (let i = 0; i < ticket_ids.length; i++) {
                    let ticket_id = ticket_ids[i];
                    axios
                        .post(self.urls.add_ticket_url, {
                            ticket_id: ticket_id
                        })
                        .then(function (response) {
                            // console.log('response.data',response.data)
                            if (response.data.success) {
                                self.formatTicketsForEntity([response.data.ticket]);
                                // console.log('response.data.ticket',response.data.ticket)
                                // console.log(' self.ticketsToEntities', self.ticketsToEntities);
                                for (let i = 0; i < self.ticket_select_items.length; i++) {
                                    if (self.ticket_select_items[i].id === ticket_id) {
                                        self.ticket_select_items.splice(i, 1);
                                        break;
                                    }
                                }
                                // console.log('self.$refs.ticket_chooser_select',self.$refs.ticket_chooser_select);
                                self.ticket_chooser.select_items = self.ticket_select_items;
                                self.$refs.ticket_chooser_select.updateMenu(self.ticket_chooser);

                                // update the tickets summary for the event
                                self.createSummary();
                                // self.editTicket(response.data.ticket, 'item-' + response.data.ticket.id);

                            }
                        })
                        .catch(function () {

                        });
                }
                self.ticket_selected_to_import = null;
            },

            importEntity(entity_id) {
                let self = this;

                axios
                    .post(self.urls.add_entity_url, {
                        entity_id: entity_id
                    })
                    .then(function (response) {
                        if (response.data.success) {
                            console.log('response.data', response.data)
                            // self.loadTickets();
                            self.$refs.entity_chooser_select.updateMenu(self.entity_chooser);
                            self.readTickets();
                        }
                    })
                    .catch(function () {

                    });
            },
            /**
             * Trigger delete of ticket. Will check if it can be first by testing for sales
             * */
            deleteTicketConfirm(ticket) {
                if (ticket.sale_contents.length > 0 && ticket.ticket_type === 'single') {
                    //ticket has sales, we cannot remove it;

                    this.confirm_alert.message = `
<h4 class="text-center">
    <i class="fa fa-exclamation-triangle fa-4x mb-3"></i>
    <strong class="text-danger">Ticket cannot be removed!</strong>
</h4>
<div class="text-center mt-3">
    <p>Would you like to disable the ticket?</p>
</div>
`;

                    this.confirm_alert.call_back = this.disableTicket;
                    this.confirm_alert.arg = ticket;
                    $('#event-ticket--confirm_alert').modal();
                } else {
                    this.confirm_alert.message = `
<div class="text-center mt-3">
    <i class="fa fa-exclamation-triangle fa-4x mb-3"></i>
    <p>Are you sure you want to remove this ticket?</p>
</div>
`;

                    this.confirm_alert.call_back = this.deleteTicket;
                    this.confirm_alert.arg = ticket;
                    $('#event-ticket--confirm_alert').modal();
                }
                console.log('delete ticket.id', ticket.id);
            },

            deleteTicket(ticket) {
                let self = this;

                axios.post(self.urls.remove_ticket_url, {
                    ticket_id: ticket.id,
                    event_id: self.event_id
                })
                    .then(function (response) {
                        if (response.data.success) {

                            let ticketSlug = response.data.ticket.slug,
                                entitySlug = response.data.ticket.entity.slug,
                                ticketLocation = -1,
                                length = self.ticketsToEntities[entitySlug].length
                            ;

                            for (let i = 0; length > i; ++i) {

                                let entityId = self.ticketsToEntities[entitySlug][i].entity_id,
                                    ticketId = self.ticketsToEntities[entitySlug][i].id;

                                if (ticketId == ticket.id) {
                                    if (length == 1) {
                                        Vue.delete(self.ticketsToEntities, entitySlug);
                                    } else {
                                        Vue.delete(self.ticketsToEntities[entitySlug], i);
                                    }
                                    break;
                                }
                            }
                            self.readAllTicketsAssignableForImport();
                        }
                    })
                    .catch(function () {

                    });
            },

            disableTicket(ticket) {
                ticket.status = 'inactive';
                this.saveTicket(ticket);
            },

            ultraEditTicket(ticket) {
                window.location.href = this.urls.ticket_edit_url + '/' + ticket.id;
            },
            /**
             *  toggles ticket status
             * */
            toggleActive(ticket) {
                ticket.status = (
                                    ticket.status === 'active'
                                ) ? 'inactive' : 'active';
            },
            isActive(ticket) {
                // console.log('ticket', ticket);
                let isDisabled = ticket.status !== 'active' ? 'disabled-color' : '';

                return ticket.status === 'active' ? 'bg-info' : 'disabled-color';
            },
            isActiveCheck(ticket) {
                return ticket.status === 'active' ? 'checked' : '';
            },

            /**
             *  Edit ticket was toggled
             * */
            editTicket(ticket, itemId) {
                let self = this, ticketId = ticket.id;
                // console.log('self.current_ticket closing or opening', self.current_ticket);

                /**
                 * check if the time slot has been selected
                 */
                if (self.timeSlotActive()) {
                    self.createTimeSlot();
                    return;
                }
                $('.ticket-items').find('.card').removeClass(this.selectedDepthCls);

                // console.log('ticket.edit_mode before', ticket.edit_mode);

                // edit mode for new ticket
                // ticket has not been edit_mode before
                if (!ticket.hasOwnProperty('edit_mode')) {
                    //since its the first time , set the value of edit_mode to true to show the subitem
                    self.$set(ticket, 'edit_mode', true);
                } else {
                    ticket.edit_mode = !ticket.edit_mode;
                }

                // console.log('ticket.edit_mode after', ticket.edit_mode, 'self.current_ticket',self.current_ticket);

                // final validation
                if ('id' in self.current_ticket) {
                    if (ticketId !== self.current_ticket.id) {
                        console.log('no match', ticketId, self.current_ticket.id);
                        return;
                    }
                }
                if (ticket.edit_mode === true) {
                    self.layout.previous = self.layout.current;
                    self.layout.current = 'list';
                    self.current_ticket = $.extend(true, {}, ticket);

                    self.current_ticket.edit_price = (
                        parseFloat(ticket.price) / 100
                    ).toFixed(2);

                    //                    self.current_ticket.edit_price  = parseFloat(self.formatPrice());

                } else {
                    // console.log('this.current_ticket', this.current_ticket);
                    if (this.getValidSales(ticket).length > self.current_ticket.allocated) {
                        //We have more sales than allocation
                        toastr.error('The amount tickets sold exceeds spaces allocated');
                        ticket.edit_mode = !ticket.edit_mode;
                    } else {
                        self.layout.current = self.layout.previous;
                        // NOTE only triggered when save is pressed

                        ticket.allocated = self.current_ticket.allocated;
                        ticket.status = self.current_ticket.status;

                        // update price. the value is set as float so we must multiply 100
                        ticket.price = self.current_ticket.edit_price * 100;

                        ticket.ticket_event_attributes = self.current_ticket.ticket_event_attributes;
                        // console.log('self.current_ticket.ticket_event_attributes',
                        //     self.current_ticket.ticket_event_attributes);

                        ticket.ticket_data.lang[self.lang].title =
                            self.current_ticket.ticket_data.lang[self.lang].title;

                        self.current_ticket = {};

                        self.saveTicket(ticket);
                    }
                }
                self.edit_mode = ticket.edit_mode;

                self.scrollTo(itemId);
                self.last_ticket = ticketId;
            },
            scrollTo(itemId, speed) {
                if (typeof speed === 'undefined') {
                    speed = 600;
                }
                setTimeout(function () {
                    let navHeight = $('#main-navigation').height(),
                        calc = $('#' + itemId).offset().top - (
                            navHeight + 50
                        );
                    $('html, body').animate({
                        scrollTop: calc
                    }, 200);
                }, speed);
            },

            /**
             * Saving ticket from quick edit
             * */
            saveTicket(ticket) {
                let self = this;

                ticket.allocated = parseInt(ticket.allocated);
                // console.log('saveTicket ticket', ticket);

                axios.post(self.urls.update_ticket_url, {
                    ticket: ticket
                })
                    .then(function () {
                        self.createSummary();
                    });
            },

            getAllTicketsBelongingToEntityId(entity_id) {
                let tickets_with_entity = [];
                // console.log('this.tickets',this.tickets);
                this.tickets.forEach(ticket => {
                    if (ticket.entity_id === entity_id) {
                        tickets_with_entity.push(ticket);
                    }
                });
                // console.log('getAllTicketsBelongingToEntityId tickets_with_entity', tickets_with_entity);
                return tickets_with_entity;
            },

            allocatedOnEntity(entity_id) {
                let number_allocated = 0;
                for (let entity in this.ticketsToEntities) {
                    // console.log('entity',entity);
                    this.ticketsToEntities[entity].forEach(ticket => {
                        if (ticket.entity_id === entity_id && ticket.status === 'active') {
                            number_allocated += ticket.allocated;
                        }
                    });
                }

                return number_allocated;
            },

            /**
             * Reset the current ticket because the user pressed cancel or another ticket was selected
             * */
            resetForm(ticket) {
                let itemId = ticket.id;
                this.layout.current = this.layout.previous;

                ticket.edit_mode = this.edit_mode = false;
                this.current_ticket = {};
                this.scrollTo('item-' + itemId);
            },

            /**
             * Reads attribute from ticket -> ticket events attribute relationship
             * @param ticket    The ticket object
             * @param type  the type field
             * @param attributeValuePath  path pointing to value. Either dot separated string or array
             * @param   fallback    if this is declared then run the method using this path
             */
            readEventTicketAttribute(ticket, type, attributeValuePath, fallback) {
                // get the first record matching the type
                let attributeData = _.findWhere(ticket.ticket_event_attributes, {type: type}),
                    value = null;

                // if there is no record then get this
                if (!_.isEmpty(attributeData)) {
                    value = getByPath(attributeData.ticket_event_attribute_data, attributeValuePath);
                    return value;
                }

                if (typeof fallback !== 'undefined') {
                    value = getByPath(ticket, fallback);
                }

                return value;
            },
            createTicketTypeRestriction(type) {
                let editRestrictionsList = ['season', 'vip'];
                return _.indexOf(editRestrictionsList, type) > -1 ? true : false;
            },
            ticketType(type) {
                let ticketType = '';

                if (this.ticket_types.hasOwnProperty(type)) {
                    ticketType = 'icon-tilt-' + this.ticket_types[type].icon;
                } else if (type === 'total') {
                    ticketType = 'fa fa-home';
                } else {
                    console.error(type + ' not found in ', this.ticket_types);
                    ticketType = 'fa fa-exclamation';
                }

                return ticketType;
            },
            ticketTypeAndActive(ticket) {
                let active = this.isActive(ticket);
                let type = this.ticketType(ticket.ticket_type);
                return active + ' ' + type;
            },

            getValidSales(ticket) {
                // console.log('getValidSales', 'ticket', ticket);
                let
                    sale_contents = ticket.sale_contents,
                    sales = [];
                // console.log('getValidSales', 'sale_contents',sale_contents);
                for (let i = 0; i < sale_contents.length; i++) {
                    let sale_content = sale_contents[i];

                    if (sale_content.status !== 'cancelled' && sale_content.status !== 'disabled') {
                        sales.push(sale_content);
                    }
                }

                return sales;
            },

            readEarnings(ticket) {
                let sales = this.getValidSales(ticket),
                    paid = 0;
                // console.log('readEarnings', 'sales',sales);
                sales.forEach(function (sale_content) {
                    let paidFor = sale_content.price_paid;

                    paid += paidFor - sale_content.sale.total_amount_refunded;
                });
                return this.createMoney(paid);
            },
            /*
             * as the user types, fill in the input from last to first
             */
            readPrice(ticket, id) {
                if ('edit_price' in ticket) {
                    ticket.original_price = ticket.price;
                    document.getElementById(id).value = this.formatPrice(ticket);

                    // console.log('ticket',ticket)
                }
            },
            formatDateToTime(date) {
                let dateTime = new Date(date);
                //2018-02-28 12:00:00
                return moment(dateTime, 'YYYY-MM-DD HH:mm:ss').format('HH:mm');
            },
            formatDate(date) {
                let dateTime = new Date(date);
                //2018-02-28 12:00:00
                return moment(dateTime, 'YYYY-MM-DD HH:mm:ss').format('MMM Do');
            },
            /**
             * Hacky but works. parses a string back to the input
             * @returns {number}
             */
            formatPrice(ticket) {
                let thePriceValue = parseFloat(ticket.edit_price).toFixed(2);

                if (isNaN(thePriceValue) || thePriceValue < 0) {
                    thePriceValue = (
                        parseFloat(ticket.original_price) / 100
                    ).toFixed(2);
                }

                return thePriceValue;
            },
            createMoney(price, noCode) {
                if (price.length <= 0) {
                    return null;
                }
                //                console.log('price', price);
                let data = {
                    code: this.currency
                };
                if (typeof noCode !== 'undefined') {
                    data = {};
                }
                return formatMoney(price, data);
            },
            enter(enter) {
                console.log('enter', enter);
            },
            /**
             * Displays simple stats above the tickets like allocation,used etc for each ticket type
             * */
            createSummary() {
                let summaryTickets = {
                        total: {
                            active: true,
                            allocated: 0,
                            used: 0
                        }
                    },
                    totalTickets = 0;

                for (let entity in this.ticketsToEntities) {
                    // console.log('entity',entity);
                    // iterate though the entity
                    // console.log('this.ticketsToEntities[entity]',this.ticketsToEntities[entity]);
                    totalTickets = totalTickets + this.ticketsToEntities[entity].length;
                }
                // iterate through the entityTickets
                // console.log('totalTickets',totalTickets);

                this.summary.count = totalTickets;
                // console.log('this.tickets', this.tickets);

                for (let entity in this.ticketsToEntities) {

                    for (let i = 0; i < this.ticketsToEntities[entity].length; i++) {

                        let type = this.ticketsToEntities[entity][i].ticket_type;
                        if (!(type in summaryTickets)) {
                            summaryTickets[type] = {
                                allocated: 0,
                                used: 0,
                                count: 0,
                                active: false
                            };
                        }
                        let used = this.readUsed(this.ticketsToEntities[entity][i]);

                        if (this.ticketsToEntities[entity][i].status === 'active') {
                            summaryTickets[type].allocated += this.ticketsToEntities[entity][i].allocated;

                            summaryTickets[type].used += used;

                            summaryTickets.total.allocated += this.ticketsToEntities[entity][i].allocated;
                            summaryTickets.total.used += used;
                            if (type !== 'total') {
                                summaryTickets[type].count = ++summaryTickets[type].count;

                            }
                        }
                    }

                }
                this.summary.tickets = summaryTickets;
                // console.log('this.summary.tickets', this.summary.tickets);
            },
            readUsed(ticket) {
                let count = 0;

                if (ticket.wastage.length > 0 || ticket.received_wastage_transfers.length > 0) {
                    this.wastage_applied_toself_event = true;
                }

                ticket.sale_contents.forEach(function (sale_content) {
                    if (sale_content.status === 'active') {
                        count++;
                    }
                });

                ticket.wastage.forEach(function (wastage) {
                    if (wastage.date_expired) {
                        if (Date.now() > Date.parse(wastage.date_expired)) {
                            if (ticket.ticket_type === 'single') {
                                count -= wastage.wastage_transfers.length;
                            }
                        } else {
                            count += wastage.spaces;
                            count -= wastage.wastage_transfers.length;
                        }
                    } else {
                        count += wastage.spaces;
                        count -= wastage.wastage_transfers.length;
                    }
                });

                count += ticket.received_wastage_transfers.length;

                return count;
            },
            /**
             * Requests tickets from server
             */
            readTickets() {
                let self = this;

                self.loading = true;
                axios({
                    method: 'get',
                    url: self.urls.url,
                    params: {}
                }).then((response) => {
                    if (response.status !== 200) {
                        self.disableAll();
                    }
                    self.loading = false;
                    self.formatTicketsForEntity(response.data.tickets);
                    self.createSummary();
                }).catch(function (error) {
                    console.error(error);
                });
            },

            /**
             * prepares the dataset for the template
             * */
            formatTicketsForEntity(tickets) {
                let self = this;

                tickets.forEach(ticket => {
                    // console.log('', 'row.entity', row, row.entity);
                    let entitySlug = ticket.entity.slug;

                    if (!self.ticketsToEntities.hasOwnProperty(entitySlug)) {

                        self.ticketsToEntities[entitySlug] = [];
                    }
                    // console.log('row', row);

                    let ticketIndex = _.findIndex(self.ticketsToEntities[entitySlug], {id: ticket.id});
// console.log('row',row)
                    if (ticketIndex < 0) {
                        self.ticketsToEntities[entitySlug].push(ticket);

                    } else {
                        self.ticketsToEntities[entitySlug][ticketIndex] = ticket;
                    }
                    if (!self.entities_cache.hasOwnProperty(ticket.entity_id)) {
                        self.entities_cache[ticket.entity_id] = {
                            sold: 0,
                            allocated: 0,
                            remaining: 0,
                            tickets: {}
                        };
                    }
                    let sold = 0;
                    _.map(ticket.sale_contents, function (data) {
                        if (data.status === 'active') {
                            sold = ++sold;
                        }
                        return false;
                    });

                    self.entities_cache[ticket.entity_id].sold = self.entities_cache[ticket.entity_id].sold + sold;
                    self.entities_cache[ticket.entity_id].allocated = self.entities_cache[ticket.entity_id].allocated + ticket.allocated;

                    if (!self.entities_cache[ticket.entity_id].tickets.hasOwnProperty(ticket.id)) {
                        self.entities_cache[ticket.entity_id].tickets[ticket.id] = {
                            sold: sold,
                            allocated: ticket.allocated,
                            remaining: 0,
                        }
                    }
                });
                self.ticketsOriginal = clone(self.ticketsToEntities);
            },
            timeSlotActive() {
                if (typeof this.add_time_slot !== 'undefined' && this.add_time_slot !== null) {
                    return (
                        this.add_time_slot.start !== '' && this.add_time_slot.end !== ''
                    ) || false;
                } else {
                    return false;
                }
            },
            /**
             * Requests all entities that are assignable.
             */
            readAllEntitiesAssignableForImport() {
                let self = this;
                this.loading = true;
                axios({
                    method: 'get',
                    url: self.urls.all_entities_url
                }).then((response) => {
                    if (response.status !== 200) {
                        self.disableAll();
                    }
                    // this.loading = false;
                    // wipe first
                    this.createEntitySelectList(response);
                    //                    this.createSummary();
                    //                    console.log('self.tickets', self.tickets);
                }).catch(function (error) {
                    console.error(error);
                });
            },
            /**
             * Requests all tickets that are assignable. Single tickets will be added
             * if not already assigned to another event
             */
            readAllTicketsAssignableForImport() {
                let self = this;
                this.loading = true;
                axios({
                    method: 'get',
                    url: self.urls.all_tickets_url
                }).then((response) => {
                    if (response.status !== 200) {
                        self.disableAll();
                    }
                    this.loading = false;
                    // wipe first
                    this.createSelectList(response);
                    //                    this.createSummary();
                    //                    console.log('self.tickets', self.tickets);
                }).catch(function (error) {
                    console.error(error);
                });
            },
            // create the list of available now entities
            createSelectList(response) {
                let self = this, groups = [];

                this.ticket_select_items = [];
                response.data.forEach(function (row) {
                    // type does not exist so create it
                    if (groups.indexOf(row.ticket_type) === -1) {
                        groups.push(row.ticket_type);
                    }
                    self.ticket_select_items.push(row);
                });
                // console.log('self.ticket_select_items', self.ticket_select_items);
                this.initMaterialSelect(groups);
            },
            // create the list of available now entities
            createEntitySelectList(response) {
                let self = this, groups = [];

                this.entities_select_items = [];
                /**
                 * @property row.entity_type
                 * @namespace row
                 */
                response.data.forEach(function (row) {
                    // type does not exist so create it
                    if (groups.indexOf(row.entity_type) === -1) {
                        groups.push(row.entity_type);
                    }
                    self.entities_select_items.push(row);
                });
                this.initEntityMaterialSelect(groups);
            },

            initMaterialSelect: function (groups) {
                this.ticket_chooser = {
                    params: {
                        emit_path: 'material_select_result',
                        submitAction: {
                            active: true,
                            emit_path: 'material_select_submit',
                            text: 'import ticket'
                        },
                        multiple: true,
                        //                        grouped: [],
                        grouped: groups,
                        group_by: 'ticket_type',
                        top_option: {
                            title: 'Add existing ticket'
                        },
                        selected_input_name: 'tickets_select',
                        label: 'Import ticket',
                        placeholder: 'Select Ticket',
                        id: uniqueId('ticket_chooser'),
                        link: {
                            add: true,
                            url: this.urls.ticket_create_url,
                            icon: 'fa-plus',
                            text: 'Create a new ticket'
                        }
                    },
                    select_items: this.ticket_select_items
                };
                // console.log('this.ticket_select_items', this.ticket_select_items);
                let ticket_chooser = this.ticket_chooser;
                // console.log('this.material_select_controllers.ticket)', this.material_select_controllers.ticket);
                this.$root.$emit(this.material_select_controllers.ticket, ticket_chooser);

            },
            initEntityMaterialSelect: function (groups) {
                this.entity_chooser = {
                    params: {
                        emit_path: 'material_select_entity_result',
                        submitAction: {
                            active: true,
                            emit_path: 'material_select_entity_submit',
                            text: 'submit'
                        },
                        multiple: true,
                        //                        grouped: [],
                        grouped: groups,
                        group_by: 'entity_type',
                        top_option: {
                            title: 'Add existing entity'
                        },
                        selected_input_name: 'entities_select',
                        label: 'Import entity',
                        placeholder: 'Select entity',
                        id: uniqueId('entity_chooser'),
                        link: {
                            add: false
                            // url: this.urls.all_entities_url,
                            // icon: 'fa-plus',
                            // text: 'Create a new ticket'
                        }
                    },
                    select_items: this.entities_select_items
                };
                // console.log('this.ticket_select_items', this.ticket_select_items);
                let entity_chooser = this.entity_chooser;
                // console.log('entity_chooser.params.emit_path', entity_chooser.params.emit_path);

                this.$root.$emit(this.material_select_controllers.entity, entity_chooser);

            },
            materialSelectItemSelected(items) {
                // console.log('items', items);
                this.ticket_selected_to_import = _.pluck(items, 'optionValue');
                this.importTicket(this.ticket_selected_to_import);
            },
            // manages callback from the select event
            materialEntitySelectItemSelected(items) {
                // console.log('items', items);

                this.entity_selected_to_import = _.pluck(items, 'optionValue');
                this.importEntity(this.entity_selected_to_import);
                // console.log('this.entity_selected_to_import',this.entity_selected_to_import);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/pages/ticketing/EventTickets.vue?66f5d865